import { render, staticRenderFns } from "./IconShootingType.vue?vue&type=template&id=23c79a18"
import script from "./IconShootingType.vue?vue&type=script&lang=js"
export * from "./IconShootingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports